
import moment from 'moment';
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import axios from '../../API/axios';
import { people } from '../../config/imagesLink';
import MessageInteraction from './MessageInteraction';

import { useTranslation } from "react-i18next";
import { getChatUnreadCount } from "../../utils/chatReadUtils";

const ArchivedMessage = ({ isShown, getChatList, archiveMessage, item, index, archiveActive, setArchiveActive, UserId, setMsgId, getArchivedList, getMessageList }) => {
    // console.log(item);
    const sessionId = localStorage.getItem('sessionId')
    const [archivedList, setArchivedList] = useState([])
    const formattedTime = moment(item.lastMsgTime).fromNow();
    const { t } = useTranslation();

    const getUserImage = (image) =>
        !image || image === "" ? people.DefaultProfile : image;

    const handleImageError = (e) => {
        e.target.src = people.DefaultProfile;
    };

    const isBlockedByYou =
        item.chatInfo?.isBlockedByYou === true || item.isBlockedByYou === true;

    const unreadCount = getChatUnreadCount(item);
    const isCurrentChat =
        UserId &&
        UserId !== "All" &&
        String(item.chatInfo?.toUserUid) === String(UserId);
    const showUnreadBadge = unreadCount > 0 && !isCurrentChat;
    const unreadBadgeLabel = unreadCount > 99 ? "99+" : unreadCount;

    return (
        <>
            <Link to={`/Message/${item?.chatInfo?.toUserUid}`} onClick={() => { }}>
                <div onClick={() => {
                    setArchiveActive(index)
                    // setToUserId(item.chatInfo.toUserUid)
                    setMsgId(item.chatInfo.msgID)
                }} className={`${isShown ? 'd-block' : 'd-md-block d-none'} pointer`}>
                    <div key={index} className={`${archiveActive === index ? 'activeMsg' : ''}
                     message-cards d-flex align-items-center mb-2`}
                     style={{ height : "70px"}}
                     >
                        {/* <div className="empty-msg-card ms-3 me-3"></div> */}
                        <div className="me-3 ms-2">
                            <img
                                src={getUserImage(item.chatInfo?.toUserImage)}
                                onError={handleImageError}
                                alt=""
                                width={40}
                                height={40}
                                style={{ borderRadius: '50px' }}
                            />
                        </div>
                        <div className="msg-content w-100 me-2">
                            <div className="name-time d-flex justify-content-between align-items-baseline">
                                <div className="message-user-name darkmode f-12 f-600">
                                    {/* {item.chatInfo.toUserFullName} */}
                                  {(item.chatInfo.toUserFullName?.length > 20 ? item.chatInfo.toUserFullName.slice(0, 20) + "..." : item.chatInfo.toUserFullName)}

                                    </div>
                                <div
                                    className={`message-time darkmode f-10 f-400 ${
                                        showUnreadBadge ? "message-time-unread" : ""
                                    }`}
                                >
                                    {moment.utc(item.lastMsgTime).local().format("LT")}
                                </div>
                            </div>
                            <div className='d-flex justify-content-between align-items-center'>
                                <div
                                    className={`${
                                        item.lastMsgIsRead === false ? "fw-bolder f-14" : "fw-normal f-10"
                                    } messageText darkmode`}
                                >
                                    <p className='messageText'>
                                    {isBlockedByYou ? (
                                        <span className="text-muted f-10">
                                            {t("Newsfeed.Want to continue chat with this user")}{" "}
                                            {t("Newsfeed.Unblock from settings")}
                                        </span>
                                    ) : (
                                        (item.lastMsg?.length > 20 ? item.lastMsg.slice(0, 20) + "..." : item.lastMsg)
                                    )}
                                </p>
                                </div>
                                <div className="d-flex align-items-center">
                                    {showUnreadBadge ? (
                                        <span
                                            className={`msg-unread-badge ${
                                                unreadCount > 9 ? "msg-unread-badge-wide" : ""
                                            }`}
                                        >
                                            {unreadBadgeLabel}
                                        </span>
                                    ) : null}
                                    <div
                                    // onClick={(e) => e.stopPropagation()}
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        e.preventDefault(); // Prevents Link's default navigation
                                    }}
                                >
                                <MessageInteraction 
                                chatId={item.chatID}
                                 isRead={item.lastMsgIsRead} 
                                 isPined={item.isPined} 
                                 getChatList={getChatList} 
                                 archiveMessage={archiveMessage} 
                                 msgId={item.chatInfo.msgID}
                                 usermsgId={item.chatInfo.msgID}
                                 UserId={item.chatInfo.toUserUid}
                                 toUserUId={item.chatInfo.toUserUid}
                                  getArchivedList={getArchivedList} 
                                  getMessageList={getMessageList} />
                            </div>
                            </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Link>

        </>
    )
}

export default ArchivedMessage